import React from "react";
import "./FloatingPromo.css";

const FlyingGirl = () => {
    return (
        <>
            {/* Top Girl */}
            <div className="flying-girl-wrapper top">
                <img
                    src="/assets/images/banners/girl.gif"
                    alt="Top Girl"
                    className="top-girl-image"
                />
            </div>

            {/* Bottom Girl */}
            <div className="flying-girl-wrapper bottom">
                <img
                    src="/assets/images/banners/babies.gif"
                    alt="Bottom Girl"
                    className="bottom-girl-image"
                />
            </div>
        </>
    );
};

export default FlyingGirl;